module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editScenarioDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "project-management-scenario-close-dialog-cross",
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SC0000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.SC0020) + ":")]), _vm._v("\n          " + _vm._s(_vm.selectedClient) + " - " + _vm._s(_vm.nameOfSelectedClient) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterScenarioString),
      expression: "filterScenarioString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SC0011
    },
    domProps: {
      "value": (_vm.filterScenarioString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterScenarioString = $event.target.value
      }, function($event) {
        return _vm.doFilteringScenarios()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    key: _vm.selectedClient,
    staticClass: "form-control",
    attrs: {
      "id": "selectedClientSelect",
      "afterChange": _vm.getScenariosOfSelectedClient
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: 'option_' + client.ClientId,
      domProps: {
        "value": parseInt(client.ClientId)
      }
    }, [_vm._v("\n                    " + _vm._s(client.ClientName) + "\n                  ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container table-scenarios",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0012) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0013) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0014) + "\n                      ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredScenarios), function(scenario) {
    return _c('tr', {
      key: scenario.ScenarioGuid,
      class: {
        info: _vm.isScenarioSelected(scenario.ScenarioGuid),
        'cursor-not-allowed': _vm.selectedTab === 'assignClientTab' &&
          _vm.selectedClient < 0,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario.ScenarioGuid)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                        " + _vm._s(scenario.ScenarioDescription) + "\n                      ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-scenario-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editScenarioTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editScenarioTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0007))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editScenarioTab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioName),
      expression: "selectedScenario.ScenarioName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputScenarioName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioName", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioLongtext"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioLongtext),
      expression: "selectedScenario.ScenarioLongtext"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputScenarioLongtext",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioLongtext)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioLongtext", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioDescription),
      expression: "selectedScenario.ScenarioDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioDescription", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedScenario.ScenarioId
    },
    on: {
      "click": function($event) {
        return _vm.createNewScenario()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0010) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedScenarioDirty
    },
    attrs: {
      "type": "button",
      "id": "project-management-scenario-save",
      "disabled": _vm.selectedScenario.ScenarioName.length < 1 ||
        (!_vm.globals.isAccessAllowed('LoopOp_Scenarios_Create') &&
          !_vm.selectedScenario.ScenarioId) ||
        (!_vm.globals.isAccessAllowed('LoopOp_Scenarios_Update') &&
          _vm.selectedScenario.ScenarioId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedScenario()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0002) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedScenario.ScenarioId ||
        _vm.selectedScenario.ScenarioId < 0 ||
        !_vm.globals.isAccessAllowed('LoopOp_Scenarios_Delete')
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteScenarioConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0003) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "assignClientTab"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterClientString),
      expression: "filterClientString"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "type": "search",
      "placeholder": 'Filter'
    },
    domProps: {
      "value": (_vm.filterClientString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterClientString = $event.target.value
      }, function($event) {
        return _vm.doFilteringClients()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.unsavedAssignments
    },
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedClient < 0 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_ClientsScenarios_Update'
        )
    },
    on: {
      "click": function($event) {
        return _vm.saveScenariosOfSelectedClient()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SC0002) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.copyScenarios
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedClient < 0 && !_vm.copyScenarios
    },
    on: {
      "click": function($event) {
        return _vm.copyScenariosClicked()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SC0001) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.SC0012) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.SC0009) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredClients), function(client) {
    return _c('tr', {
      key: client.ClientId,
      class: {
        info: _vm.isClientSelected(client.ClientId)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectClient(client.ClientId)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(client.ClientId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v(_vm._s(client.ClientName))])])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "project-management-scenario-close-dialog-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SC0006) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4876088e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectManagement/ScenarioEditModal.vue
// module id = 621
// module chunks = 1 2